import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { SiteGroupMember, siteGroupMemberSchema } from '@sophocles/entities/SiteGroupMember/siteGroupMemberRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_SITE_GROUP_MEMBERS = 'RECEIVE_SITE_GROUP_MEMBERS';
function receiveSiteGroupMembers(json) {
  return {
    type: RECEIVE_SITE_GROUP_MEMBERS,
    siteGroupMembers: mapListToRecords(json, SiteGroupMember),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SITE_GROUP_MEMBER = 'REQUEST_SITE_GROUP_MEMBER';
function requestSiteGroupMember(siteGroupMember_id) {
  return {
    type: REQUEST_SITE_GROUP_MEMBER,
    siteGroupMember_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSiteGroupMember(siteGroupMember_id) {
  return dispatch => {
    dispatch(requestSiteGroupMember(siteGroupMember_id));
    return apiClient
      .get(`/sitegroupmembers/${siteGroupMember_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'siteGroupMembers', siteGroupMemberSchema))
      .then(json => dispatch(receiveSiteGroupMembers(json.entities.siteGroupMembers)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_GROUP_MEMBER)));
  };
}

export function fetchSiteGroupMemberForSiteAndSiteGroup(site, siteGroup) {
  return dispatch => {
    dispatch({ type: REQUEST_SITE_GROUP_MEMBER, site, siteGroup });
    return (
      apiClient
        .get(`/sitegroupmembers/?site=${site}&site_group=${siteGroup}`)
        .then(checkHttpStatus)
        .then(response => fromJS(response.data))
        // .then(response => normalizeList(response.data, 'siteGroupMembers', siteGroupMemberSchema))
        .catch(error => dispatch(genericErrorAction(error, REQUEST_SITE_GROUP_MEMBER)))
    );
  };
}

/* Edit Actions */
export const EDIT_SITE_GROUP_MEMBER = 'EDIT_SITE_GROUP_MEMBER';
export function editSiteGroupMember(siteGroupMember_id) {
  return {
    type: EDIT_SITE_GROUP_MEMBER,
    siteGroupMember: siteGroupMember_id,
  };
}

export function patchSiteGroupMember(siteGroupMember_id, values) {
  return dispatch => {
    dispatch(editSiteGroupMember(siteGroupMember_id));
    return (
      apiClient
        .patch(`/sitegroupmembers/${siteGroupMember_id}/`, values)
        .then(checkHttpStatus)
        .then(response => fromJS(response.data))
        // .then(response => normalize(response.data, siteGroupMemberSchema))
        // .then(json => dispatch(receiveSiteGroupMembers(json.entities.siteGroupMembers)))
        .catch(error => dispatch(genericErrorAction(error, EDIT_SITE_GROUP_MEMBER)))
    );
  };
}

/* Delete Actions */
export const DELETE_SITE_GROUP_MEMBER = 'DELETE_SITE_GROUP_MEMBER';
function sayDeleteSiteGroupMember(siteGroupMember_id) {
  return {
    type: DELETE_SITE_GROUP_MEMBER,
    siteGroupMember: siteGroupMember_id,
  };
}

export function deleteSiteGroupMember(siteGroupMember_id) {
  return dispatch =>
    apiClient
      .delete(`/sitegroupmembers/${siteGroupMember_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSiteGroupMember(siteGroupMember_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_SITE_GROUP_MEMBER)));
}
